(function($) {


    $(document).ready(function() {
        field_focus();
        form_states1();
        $('.form-with-content .row-wrap select').click(function() {

            $(this).parent().toggleClass('rotate-arrow');
            //$(this).siblings('span').find('ul').fadeToggle(100);
            $('.form-with-content .row-wrap select').not($(this)).parent().removeClass('rotate-arrow');
            //$('.form-with-content .row-wrap select').not($(this)).siblings('span').find('ul').fadeOut(100);
        });

        $(document).on("click", ".form-with-content .selectboxit-list", function(e) {
            // e.stopImmediatePropagation();
            $(".form-with-content .select-box").removeClass("rotate-arrow");
            $(".form-with-content .select-box").addClass("text-black");
        });

        $(document).click(function(e) {
            if (!e.target.closest('.form-with-content .row-wrap.select-box')) {
                $(".form-with-content .select-box").removeClass("rotate-arrow");
                $(".form-with-content .select-box").addClass("text-black");
            }
        });

        if ($('.form-with-content .row-wrap .select').length > 0) {
            $(".form-with-content .row-wrap .select").selectBoxIt({
                showEffect: "fadeIn",
                showEffectSpeed: 200,
                hideEffect: "fadeOut",
                hideEffectSpeed: 200
            });
        }
        $(".form-with-content input, .we-webform-container input").focus(function() {
            $(this).parent().addClass("selected-state");
        }).blur(function() {
            $(this).parent().removeClass("selected-state");
        });

        $(".form-with-content  select, .we-webform-container select").focus(function() {
            $(this).parent().addClass("selected-state");
        }).blur(function() {
            $(this).parent().removeClass("selected-state");
        });

        $(".form-with-content  textarea").focus(function() {
            $(this).parents('.row-wrap').addClass("selected-state");
        }).blur(function() {
            $(this).parents('.row-wrap').removeClass("selected-state");
        });
        $(".we-webform-container textarea").focus(function() {
            $(this).parent().parent().addClass("selected-state");
        }).blur(function() {
            $(this).parent().parent().removeClass("selected-state");
        });

        if ($('html').hasClass('ua-mobile')) {
            $('.form-with-content ').addClass('ua-mobile');
            setTimeout(function() {
                $('.form-with-content .selectboxit').attr('unselectable', 'off');
            }, 500);


            $('body .form-with-content .selectboxit-list li').click(function() {
                $(".form-with-content .selectboxit-container").removeClass("rotate-arrow");

            });

            $(document).click(function(e) {
                if (!e.target.closest('.form-with-content .row-wrap.select-box')) {
                    $(".form-with-content .selectboxit-container").removeClass("rotate-arrow");
                    $(".form-with-content .select-box").addClass("text-black");
                }
            });

        }


        function field_focus() {
            $('.form-with-content .js-form-item, .we-webform-container .js-form-item').on('blur', 'input', function() {
                if ($(this).val()) {
                    $(this).parent().addClass('used');
                } else {
                    $(this).parent().removeClass('used');
                }
            });

            $('.form-with-content .js-form-item, .we-webform-container .js-form-item').on('blur', 'select', function() {
                if ($(this).val()) {
                    $(this).parent().addClass('used');
                } else {
                    $(this).parent().removeClass('used');
                }
            });

            $('.form-with-content .js-form-item, .we-webform-container .js-form-item').on('blur', 'textarea', function() {
                if ($(this).val()) {
                    $(this).parents('.js-form-item').addClass('used');
                } else {
                    $(this).parents('.js-form-item').removeClass('used');
                }
            });

            $(".we-webform-container .js-form-item.js-form-type-textarea").on("keyup", function(e) {

                var label_length = $(this).find("label").outerHeight() - 5;
                $(this).find("textarea").css("padding-top", +label_length + "px");

            });
        }

        $(document).ajaxComplete(function(event, request, settings) {
            form_states1();
        });

        function form_states1() {

            $('.footer-cta-with-form .form-with-content .js-form-item input').focus(function() {
                $(this).parent().addClass("selected-state");
            });
            $('.footer-cta-with-form .form-with-content .js-form-item input').blur(function() {
                $(this).parent().removeClass("selected-state");
            });

            $('.footer-cta-with-form .form-with-content .js-form-item').on('blur', 'input', function() {
                if ($(this).val()) {
                    $(this).parent().addClass('used');
                } else {
                    $(this).parent().removeClass('used');
                }
            });
        }

        window.addEventListener("pageshow", () => {
            $(':input', '.form-with-content #webform-submission-contact-us-node-125-add-form')
                .not(':button, :submit, :reset, :hidden')
                .prop('checked', false)
            if ($('.form-with-content .webform-submission-form').length > 0) {
                $('.form-with-content .webform-submission-form')[0].reset();
            }
            $(".footer-cta-with-form .form-with-content .js-form-item").removeClass("selected-state");
            $(".form-with-content .row-wrap, body .form-with-content .js-form-item").removeClass("used");
            setTimeout(function() {
                $('.form-with-content .webform-submission-form #edit-subjectSelectBoxItText').text("Select from the list..");
            }, 300);
        });
    });

    $(window).on('load resize', function() {
        setTimeout(function() {
            $(".we-webform-container .js-form-item.js-form-type-textarea").each(function() {
                var label_length = $(this).find("label").outerHeight() / 2;
                $(this).find("textarea").css("padding-top", +label_length + "px");
            });
        }, 300);
    });

    $(window).on('load', function() {
        if ($('.form-with-content .webform-submission-form').length > 0) {
            $('.form-with-content .webform-submission-form')[0].reset();
            setTimeout(function() {
                $(window).on('load', function() {
                    if ($('.form-with-content .webform-submission-form').length > 0) {
                        setTimeout(function() {
                            $('.form-with-content .webform-submission-form')[0].reset();
                            $(".form-with-content input").focus(function() {
                                $(this).parent().addClass("selected-state");
                            }).blur(function() {
                                $(this).parent().removeClass("selected-state");
                            });
                            $('.form-with-content .js-form-item').on('blur', 'input', function() {
                                if ($(this).val()) {
                                    $(this).parent().addClass('used');
                                } else {
                                    $(this).parent().removeClass('used');
                                }
                            });
                            $('.form-with-content .webform-submission-form #edit-subjectSelectBoxItText').text("Select from the list..");
                        }, 300);
                    }
                    if ($('.intro-block .description-wrap #mc_embed_signup').length > 0) {
                        $(".intro-block .description-wrap #mc_embed_signup").parent().addClass("form-with-content");
                    }
                    if ($('.full-content .container #mc_embed_signup').length > 0) {
                        $(".full-content .container #mc_embed_signup").parent().addClass("form-with-content");
                    }
                    $('.intro-block .description-wrap #mc_embed_signup form .mc-field-group').each(function() {
                        $(this).addClass("js-form-item form-item");
                    });
                    $('.full-content .container #mc_embed_signup form .mc-field-group').each(function() {
                        $(this).addClass("js-form-item form-item");
                    });
                });
                $(".form-with-content input").focus(function() {
                    $(this).parent().addClass("selected-state");
                }).blur(function() {
                    $(this).parent().removeClass("selected-state");
                });
                $('.form-with-content .js-form-item').on('blur', 'input', function() {
                    if ($(this).val()) {
                        $(this).parent().addClass('used');
                    } else {
                        $(this).parent().removeClass('used');
                    }
                });

                $('.form-with-content .webform-submission-form #edit-subjectSelectBoxItText').text("Select from the list..");
            }, 300);
        }
        if ($('.intro-block .description-wrap #mc_embed_signup').length > 0) {
            $(".intro-block .description-wrap #mc_embed_signup").parent().addClass("form-with-content");
        }
        if ($('.full-content .container #mc_embed_signup').length > 0) {
            $(".full-content .container #mc_embed_signup").parent().addClass("form-with-content");
        }
        $('.intro-block .description-wrap #mc_embed_signup form .mc-field-group').each(function() {
            $(this).addClass("js-form-item form-item");
        });
        $('.full-content .container #mc_embed_signup form .mc-field-group').each(function() {
            $(this).addClass("js-form-item form-item");
        });
    });

})
(jQuery);